/// <reference path="./Selector.ts" />
namespace HA.Core.HTML.Editor {
    export class MultiText extends Selector {

        /**
         *
         * @param txt
         */
        protected addText(txt: any) {
            if (! this.getList().hasValue(txt) && txt.toString().trim().length > 0 ) {
                this.getList().addItem(new TextItem(toMap({v: txt, s: true})));
            }
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.SelectorItem}
         */
        protected createItem(data: any) {
            return new TextItem(data);
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.MultiTextHead}
         */
        protected createHead(data?: any) {
            const me = this;
            return new MultiTextHead(toMap({
                ed: {
                    addText(txt: any) {
                        me.addText(txt);
                    },
                },
                max: this.get("max"),
            }));
        }
    }
}
